









































































import { Component, Provide, Vue } from 'vue-property-decorator';
import EditorPreview from '@/components/EditorPreview.vue';
import EditorConfig from '@/components/EditorConfig.vue';
import { db } from '@/firebase';
import { debounce } from 'lodash-es';
import { Base64 } from '@/utils/Base64';
import EditorLinkPlaceholder from '@/components/EditorLinkPlaceholder.vue';
import CHeading from './CHeading.vue';
import { allCharactersArray } from '@/custom-properties';
import EditorGenerating from '@/components/EditorGenerating.vue';
import SubscribeBox from '@/components/SubscribeBox.vue';

@Component({
    components: {
        SubscribeBox,
        EditorGenerating,
        EditorLinkPlaceholder,
        EditorConfig,
        EditorPreview,
        CHeading
    }
})
export default class Editor extends Vue {
    character = 'A';

    setName = 'abstract-avatars';

    allCharacters = allCharactersArray;

    subscribeId: string | null = null;

    subscription: any = {};

    linksSubscription: any = {};

    links: any = [];

    customProperties: any = {};

    state: 'idle' | 'loading' | 'error' = 'idle';

    get signature() {
        return Base64.encode(
            JSON.stringify({
                setName: this.setName,
                ...this.customProperties
            })
        );
    }

    mounted() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('id')) {
            this.state = 'loading';
            this.subscribeTo(params.get('id') as string);
        }
    }

    // THIS SHOULD BE DEBOUNCED
    async persistData() {
        const exists = await db
            .collection('configurations')
            .where('signature', '==', this.signature)
            .get();

        if (exists.docs.length === 0) {
            this.createConfiguration();
        } else {
            this.subscribeTo(exists.docs[0].id);
        }
    }

    subscribeTo(id: string) {
        this.state = 'loading';
        this.subscribeId = id;
        this.subscription = db
            .collection('configurations')
            .doc(this.subscribeId)
            .onSnapshot(doc => {
                const data = doc.data();

                if (data) {
                    const { signature, ...customProperties } = data;
                    Object.keys(customProperties)
                        .sort()
                        .map((key: string) => {
                            if (this.customProperties[key]) {
                                this.customProperties[key] =
                                    customProperties[key];
                            }
                        });

                    if (history.pushState) {
                        const urlWithId = `${window.location.protocol}//${window.location.host}${window.location.pathname}?id=${id}`;
                        window.history.pushState(
                            { path: urlWithId },
                            '',
                            urlWithId
                        );
                    }
                } else {
                    this.state = 'idle';
                }
            });

        this.links = [];
        this.linksSubscription = db
            .collection(`configurations/${this.subscribeId}/links`)
            .onSnapshot(doc => {
                const documents = doc.docChanges();
                documents.forEach(document => {
                    if (document.type === 'added') {
                        this.links.push(document.doc.data());
                    }
                });
            });
    }

    async createConfiguration() {
        this.state = 'loading';
        const created = await db.collection('configurations').add({
            ...this.customProperties,
            signature: this.signature,
            setName: this.setName
        });
        this.subscribeTo(created.id);
    }
}
